<template>
  <div>
    <template v-if="canAccess">
      <v-tabs align-with-title>
        <v-tab :to="{ name: 'General Ledger - Treasurers Checks - Checks' }">
          Treasurers Checks
        </v-tab>
        <v-tab :to="{ name: 'General Ledger - Treasurers Checks - Reports' }">
          Reports
        </v-tab>
      </v-tabs>
      <router-view />
    </template>
    <v-alert
      v-else
      type="warning"
      outlined
      class="ma-4"
    >
      Treasurer Checks access is limited to GL Admins.
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { canAccessTreasurerChecks } from '../../../util/shared/treasurerChecksAccess';

export default {
  name: 'TreasurersChecksUtils',
  created() {
    this.loadConfig({ requiredScope: 'glConfig' });
  },
  methods: {
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
  },
  computed: {
    ...mapState({
      glSettingItem: (state) => state.SystemConfig.glSettingItem || {},
    }),
    canAccess() {
      return canAccessTreasurerChecks(this.glSettingItem);
    },
  },
};
</script>
